import { render, staticRenderFns } from "./VideoGrey.vue?vue&type=template&id=59bfb761&"
import script from "./VideoGrey.vue?vue&type=script&lang=js&"
export * from "./VideoGrey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports